/* Timeline for the animated audit visual (snippets/hc-audit-live.liquid).
   scan → issues pop up → each issue fixed (list ticks, conversion rate climbs) → hold → loop.
   Runs only while on screen; reduced-motion visitors keep the static finished state. */
(function () {
  var root = document.querySelector('[data-hal]');
  if (!root || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var stage = root.querySelector('.hal__stage'), tip = root.querySelector('[data-hal-tip]');
  var status = root.querySelector('[data-hal-status]'), cr = root.querySelector('[data-hal-cr]');
  var fixed = root.querySelector('[data-hal-fixed]'), progress = root.querySelector('[data-hal-progress]');
  var ISSUE = { 1: 'Reviews hidden below the fold', 2: 'Add to cart blends in', 3: 'Dull, blurry product photo', 4: 'No shipping or returns info', 5: 'No sticky add to cart on mobile' };
  var FIX = { 1: 'Reviews moved above the fold', 2: 'High-contrast add to cart', 3: 'Sharp, bright product photo', 4: 'Free shipping & returns shown', 5: 'Sticky add to cart added' };
  var FOUND = [3, 1, 4, 2, 5], timers = [], running = false;

  function at(ms, fn) { timers.push(setTimeout(fn, ms)); }
  function cls(c, on) { root.classList.toggle(c, on !== false); }
  function showTip(n, good) {
    var mk = root.querySelector('[data-hal-mk="' + n + '"]');
    if (!mk || !mk.offsetParent) return hideTip();
    tip.textContent = (good ? '✓ ' : '! ') + (good ? FIX : ISSUE)[n];
    var s = stage.getBoundingClientRect(), m = mk.getBoundingClientRect();
    var x = m.left + m.width / 2 - s.left, half = tip.offsetWidth / 2 + 4;
    tip.style.left = Math.max(half, Math.min(s.width - half, x)) + 'px';
    tip.style.top = (m.top - s.top) + 'px';
    tip.className = 'hal__tip is-on ' + (good ? 'is-good' : 'is-bad');
  }
  function hideTip() { tip.classList.remove('is-on'); }
  function setScore(n) {
    var v = 1.4 + n * .3;
    cr.textContent = v.toFixed(1) + '%';
    fixed.textContent = n;
    progress.style.width = (n / 5 * 100) + '%';
    root.style.setProperty('--spark', (.55 - n * .11).toFixed(2));
    root.style.setProperty('--area', n / 5);
  }
  function reset() {
    root.className = 'hal is-live';
    hideTip(); setScore(0); status.textContent = 'Scanning page…';
  }
  function play() {
    reset();
    at(250, function () { cls('is-scan'); });
    FOUND.forEach(function (n, i) {
      at(800 + i * 520, function () { cls('mk-' + n); if (n !== 5) showTip(n, false); });
    });
    at(3300, function () { cls('is-scan', false); cls('is-found'); hideTip(); status.textContent = '5 issues found'; });
    for (var n = 1; n <= 5; n++) (function (n) {
      at(3700 + (n - 1) * 1050, function () { cls('fix-' + n); setScore(n); showTip(n, true); status.textContent = 'Fixing ' + n + ' of 5'; });
    })(n);
    at(9100, function () { hideTip(); cls('is-found', false); cls('is-done'); status.textContent = 'Fixes applied'; });
    at(12600, function () { cls('is-reset'); });
    at(13200, play);
  }
  function start() { if (running) return; running = true; play(); }
  function stop() { running = false; timers.forEach(clearTimeout); timers = []; }

  if (!('IntersectionObserver' in window)) return start();
  new IntersectionObserver(function (e) { e[0].isIntersecting ? start() : stop(); }, { threshold: .2 }).observe(root);
})();
